import useSWR from 'swr'

import { FetchError } from '../fetchError'
import { FetchResponse } from '../fetchResponse'
import { FetchResult } from '../fetchResult'
import { fetchFile, fetchJson } from '../fetchers'

export function useFile(filename: string): any {
  const fullFilename = encodeURI(`webedi/${filename}`)
  const { data, error, mutate } = useSWR<FetchResponse<any>, FetchError>(
    `/TenantFiles/?filename=${fullFilename}`,
    fetchJson,
  )

  return {
    file: data?.body,
    isFileLoading: !data && !error,
    fileError: error,
    mutate,
  }
}

export function useLocalFile(filename: string): any {
  const fullFilename = encodeURI(`${filename}`)
  const filePath = process.env.PUBLIC_URL + '/files/' + fullFilename

  const fetchFile = async () => {
    const response = await fetch(filePath)
    const data = await response.text()
    return data
  }

  const { data, error, mutate } = useSWR(`/files/${fullFilename}`, fetchFile)

  return {
    data: data,
    isLoading: !data && !error,
    error: error,
    mutate,
  }
}

export function useFileStream(filename: string): FetchResult<any> {
  const fullFilename = encodeURI(`${filename}`)
  const { data, error, mutate } = useSWR<FetchResponse<any>, FetchError>(
    `/TenantFiles/$stream?filename=${fullFilename}`,
    fetchFile,
  )

  return {
    data: data,
    isLoading: !data && !error,
    error: error,
    mutate,
  }
}
